export enum DeliverableTabPage {
  PRODUCTION = 'Production',
  TODO = 'To do',
  REPORTS = 'Reports',
}
